import validationLocationService from '../../services/job-site/useValidationLocationService'

export const VALIDATION_LOCATION_CREATE = 'VALIDATION_LOCATION_CREATE'
export const VALIDATION_LOCATION_CREATE_SUCCESS = 'VALIDATION_LOCATION_CREATE_SUCCESS'
export const VALIDATION_LOCATION_CREATE_FAILURE = 'VALIDATION_LOCATION_CREATE_FAILURE'

export const VALIDATION_LOCATION_LIST = 'VALIDATION_LOCATION_LIST'
export const VALIDATION_LOCATION_LIST_SUCCESS = 'VALIDATION_LOCATION_LIST_SUCCESS'
export const VALIDATION_LOCATION_LIST_FAILURE = 'VALIDATION_LOCATION_LIST_FAILURE'

export const VALIDATION_LOCATION_DELETE = 'VALIDATION_LOCATION_DELETE'
export const VALIDATION_LOCATION_DELETE_SUCCESS = 'VALIDATION_LOCATION_DELETE_SUCCESS'
export const VALIDATION_LOCATION_DELETE_FAILURE = 'VALIDATION_LOCATION_DELETE_FAILURE'

export const VALIDATION_LOCATION_CLEAR = 'VALIDATION_LOCATION_CLEAR'

export const list = (companyId, jobSiteId) => {
  return async dispatch => {
    dispatch({ type: VALIDATION_LOCATION_LIST })

    try {
      const response = await validationLocationService.listLocations({
        companyId,
        jobSiteId
      })

      if (!response || !response.success) {
        throw new Error(response?.message || 'Failed to fetch validation locations')
      }

      dispatch({
        type: VALIDATION_LOCATION_LIST_SUCCESS,
        payload: {
          data: response.data
        }
      })

      return response.data
    } catch (error) {
      dispatch({
        type: VALIDATION_LOCATION_LIST_FAILURE,
        error: true,
        payload: error.response?.data?.message || error.message
      })
      throw error
    }
  }
}

export const create = (companyId, jobSiteId, data) => {
  return async dispatch => {
    dispatch({ type: VALIDATION_LOCATION_CREATE })
    try {
      const response = await validationLocationService.createLocation(data, {
        companyId,
        jobSiteId
      })
      if (!response || !response.success) {
        throw new Error(response?.error || response?.message || 'Failed to create validation location')
      }
      dispatch({
        type: VALIDATION_LOCATION_CREATE_SUCCESS,
        payload: {
          data: response.data,
          message: response.message
        }
      })
      return { success: true }
    } catch (error) {
      dispatch({
        type: VALIDATION_LOCATION_CREATE_FAILURE,
        error: true,
        payload: error.response?.data?.error || error.message
      })
      return { error: error.response?.data?.error || error.message }
    }
  }
}

export const deleteLocation = (companyId, jobSiteId, locationId) => {
  return async dispatch => {
    dispatch({ type: VALIDATION_LOCATION_DELETE })
    try {
      const response = await validationLocationService.deleteLocation(locationId, {
        companyId,
        jobSiteId
      })
      if (!response || !response.success) {
        throw new Error(response?.error || response?.message || 'Failed to delete validation location')
      }
      dispatch({
        type: VALIDATION_LOCATION_DELETE_SUCCESS,
        payload: {
          locationId,
          message: response.message
        }
      })
      return { success: true }
    } catch (error) {
      dispatch({
        type: VALIDATION_LOCATION_DELETE_FAILURE,
        error: true,
        payload: error.response?.data?.error || error.message
      })
      return { error: error.response?.data?.error || error.message }
    }
  }
}

/**
 * Clear validation locations from the store
 * This is used when navigating away from a job site or creating a new job site
 * to prevent validation locations from being prefilled
 */
export const clearValidationLocations = () => {
  return {
    type: VALIDATION_LOCATION_CLEAR
  }
}
